import { Link } from "react-router-dom";
import PageShell from "../components/layout/PageShell";
import { Reveal } from "../components/ui/Reveal";
import { useFormConfig } from "../hooks/useFormConfig";

const STEPS = [
  {
    title: "Vraag je offerte aan",
    text: "Vul het formulier in met je formule, datum, uren en het aantal gasten. Je krijgt meteen een bevestiging per mail.",
  },
  {
    title: "Ontvang en onderteken",
    text: "Binnen 48 uur sturen we je offerte. Je bekijkt ze online en ondertekent met je naam. Twijfel je tussen formules? Vraag gerust een offerte per formule.",
  },
  {
    title: "Wij bevestigen",
    text: "Na je handtekening bevestigen we je boeking. Je krijgt een mail met alle gegevens en wat je precies besteld hebt.",
  },
  {
    title: "Foodtruck op locatie",
    text: "Op de dag zelf staan we er op tijd, zetten alles op en bakken elke burger vers, ter plaatse.",
  },
];

export default function WerkingInfo() {
  const config = useFormConfig();

  const practical = [
    {
      title: "Minimum aantal gasten",
      text: `We komen vanaf ${config.minimumPersonen} gasten per event. Kinderen tellen mee.`,
    },
    {
      title: "Plaats",
      text: "Een vlakke, verharde ondergrond van minstens 6 op 3 meter, bereikbaar met auto en caravan.",
    },
    {
      title: "Stroom",
      text: "Twee aparte stroomcircuits in de buurt van de foodtruck.",
    },
    {
      title: "Vegetarisch",
      text: "Elke burger bestaat ook in een vegetarische versie. Geef het aantal vegetariërs op in je aanvraag.",
    },
    {
      title: "Andere cateraars",
      text: "Laat ons weten of er nog andere foodtrucks of cateraars zijn, dan stemmen we de hoeveelheden af.",
    },
    {
      title: "Wijzigingen",
      text: "Verandert er iets aan je aantal gasten of uren? Mail ons op ontour@burgerlijk.com, dan passen we het aan.",
    },
  ];

  return (
    <PageShell>
      <section className="relative overflow-hidden bg-bl-black text-white">
        <div className="plus-pattern absolute inset-0 opacity-[0.04]" aria-hidden="true" />
        <div className="page-container relative py-12 md:py-16">
          <p className="hero-rise eyebrow">Werking &amp; info</p>
          <h1 className="hero-rise mt-4 max-w-3xl font-display text-4xl font-black tracking-tight md:text-6xl" style={{ "--rise-delay": "80ms" } as React.CSSProperties}>
            Zo komt de foodtruck naar je feest
          </h1>
        </div>
      </section>

      <section className="bg-bl-cream py-16 md:py-24">
        <div className="page-container grid gap-12 lg:grid-cols-[1fr_1.2fr]">
          <Reveal className="bg-bl-cream">
            <img src="/images/caravan-illustration.jpg" alt="" className="w-full max-w-lg mix-blend-multiply" />
          </Reveal>
          <ol className="space-y-8">
            {STEPS.map((step, index) => (
              <Reveal as="li" key={step.title} delay={index * 90} className="flex gap-5">
                <span className="font-display text-4xl font-black leading-none text-bl-gold">{index + 1}</span>
                <div>
                  <h2 className="text-xl font-bold">{step.title}</h2>
                  <p className="mt-1.5 text-bl-black/70">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="bg-white py-16 md:py-24">
        <div className="page-container">
          <Reveal>
            <p className="eyebrow">Praktisch</p>
            <h2 className="section-title mt-4">Goed om te weten</h2>
          </Reveal>
          <dl className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {practical.map((item, index) => (
              <Reveal key={item.title} delay={index * 60} className="rounded-lg bg-bl-cream p-6">
                <dt className="font-display text-lg font-bold">{item.title}</dt>
                <dd className="mt-2 text-sm text-bl-black/70">{item.text}</dd>
              </Reveal>
            ))}
          </dl>
          <Reveal className="mt-12 flex flex-col items-center gap-3 text-center">
            <p className="text-bl-black/70">Alles duidelijk?</p>
            <Link to="/offerte" className="btn-red text-base">
              Vraag je offerte aan
            </Link>
          </Reveal>
        </div>
      </section>
    </PageShell>
  );
}
